import React from 'react';
import styled from 'styled-components';
import { TextWithTooltip } from '@ubeya/shared-web/components';

const Wrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
`;

const Reason = styled(TextWithTooltip)`
  display: flex;
`;

const ClientTimesheetDeclineReason = ({ rowData: { clientDeclined } }) => {
  return (
    <Wrapper>
      <Reason>{clientDeclined?.reason || ''}</Reason>
    </Wrapper>
  );
};

export default ClientTimesheetDeclineReason;
